import { Component, HostListener } from "@angular/core";

@Component({
  selector: "app-scroll-top",
  templateUrl: "./scroll-top.component.html",
  styleUrls: ["./scroll-top.component.scss"],
  imports: [],
  standalone: true,
})
export class ScrollTopComponent {
  protected isShow: boolean;
  private readonly topPosToStartShowing = 180;

  @HostListener("window:scroll")
  protected checkScroll() {
    const scrollPosition =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    this.isShow = scrollPosition >= this.topPosToStartShowing;
  }

  protected scrollTop() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }
}
